import { AxiosResponse } from "axios";
import { APIClient } from "../axiosClient"
import { PaginationResponse, ResponseData } from "../types/_public";
import { INews, IPreviewNews, IScriptTrackingNews, IUploadImage } from "../types/newshub/_news";
import { PATH_NEWSHUB_API } from "helpers/newshub/constans";
const api = new APIClient();

const path_news = PATH_NEWSHUB_API + '/news';

const newsApi = {
  news(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `${path_news}`
    return api.get(url, params)
  },
  newsKeywords(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `${path_news}/manual`
    return api.get(url, params)
  },
  detailNews(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path_news}/${id}`
    return api.get(url, params)
  },
  preview(dataForm: any): Promise<AxiosResponse<ResponseData<IPreviewNews>, any>> {
    const url = `${path_news}/preview`;
    return api.post(url, dataForm, {
      timeout: 1000 * 60 * 10,
    })
  },
  postNews(dataForm: any): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path_news}`;
    return api.post(url, dataForm, {
      timeout: 1000 * 60 * 10,
    })
  },
  putNews(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path_news}/${id}`;
    return api.put(url, dataForm)
  },
  putReCreateNews(id: string | number, dataForm: any = {}): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path_news}/${id}/re-create`;
    return api.put(url, dataForm)
  },
  putMultiReCreateNews(dataForm: any = {}): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path_news}/re-create`;
    return api.put(url, dataForm)
  },
  putResetStatusNews(id: string | number, dataForm: any = {}): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path_news}/${id}/status/${dataForm?.status}`;
    return api.put(url, dataForm)
  },
  putMultiResetStatusNews(dataForm: any = {}): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path_news}/status`;
    return api.put(url, dataForm)
  },
  putResetNews(id: string | number, dataForm: any = {}): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path_news}/${id}/reset`;
    return api.put(url, dataForm)
  },
  putMultiSetPublishedAtNews(dataForm: any = {}): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path_news}/update`;
    return api.put(url, dataForm)
  },
  putConfirmNews(id: string | number, dataForm: any = {}): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path_news}/${id}/confirm`;
    return api.put(url, dataForm)
  },
  sendEmailNews(id: string | number, dataForm: any = {}): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path_news}/${id}/send-as-email`;
    return api.post(url, dataForm)
  },
  deleteNews(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path_news}/${id}`;
    return api.delete(url, dataForm)
  },
  downloadFile(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path_news}/${id}/download`
    return api.get(url, params)
  },
  downloadImageNews(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path_news}/${id}/download-image`
    return api.get(url, params)
  },
  downloadMediaNews(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path_news}/${id}/download-media`
    return api.get(url, params)
  },
  renderScriptTrackingNews(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<IScriptTrackingNews>, any>> {
    const url = `${path_news}/${id}/script-tracking`
    return api.get(url, params)
  },
  uploadImageOfNewsHub(dataForm: any): Promise<AxiosResponse<IUploadImage[], any>> {
    const url = `${PATH_NEWSHUB_API}/upload/r2-files`;
    // const formData = new FormData();
    // formData.append('file', file);
    return api.post(url, dataForm, {
      timeout: 1000 * 60 * 10,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  copyNews(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path_news}/${id}/plain-text`
    return api.get(url, params)
  },
  mediaPublishedNews(params: any = {}): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path_news}/media-published`
    return api.get(url, params)
  },
  mediaPublishedNewsToday(params: any = {}): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path_news}/media-published-news`
    return api.get(url, params)
  },

}
export default newsApi;